import React, { Fragment, Component } from 'react';
import {connect} from "react-redux";
import _ from "lodash";
import Joi from "@hapi/joi";
import moment from "moment";
import cx from 'classnames';

import LaddaButton, { EXPAND_LEFT } from 'react-ladda';


import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  UncontrolledTooltip,
  Button
} from 'reactstrap';

import { FooterMinimalLayout } from 'layout-components';
import BaseForm from "../BaseClass/Form";
import FormErrorWidget from "../Common/FormErrorWidget";
import ServerErrorWidget from "../Common/ServerErrorWidget";

import ProcessingModal from "../Common/ProcessingModal";

import loginLogo from '../../assets/jobelephant/images/login_logo_new.png';

//Load UI action creators and selectors
import { 
  isUserLoggedIn,
  login,
  
} from "../../store/auth";

import { 
  clearErrors,
  getLoginErrors 
} from "../../store/ui-login-screen";
// End of loading action creators and selectors

class LoginForm extends BaseForm {
  divAreaToScrollForError = "formArea";
  
  validationSchema = Joi.object({
    username: Joi.string().required().label('Email Address'),
    password:Joi.string().required().label('Password'),
    
  });

  constructor(props){
    super(props);
    this.state = {
        data:{
          username:"",
          password:"",
        },
        errors:{} 
    }
  }

  componentDidMount(){
    const {isUserLoggedIn} =  this.props;
    let documentTitle = `${window.__RUNTIME_CONFIG__['REACT_APP_PAGE_TITLE']}: Login`
    window.document.title = `${window.__RUNTIME_CONFIG__['REACT_APP_PAGE_TITLE']}: Login`
    window._paq.push(['setCustomUrl', window.location.pathname]);
    window._paq.push(['setDocumentTitle', documentTitle]);
    window._paq.push(['trackPageView']);
    
    if(isUserLoggedIn === true){
      this.redirectUser();
    }
  }

  componentDidUpdate(prevProps){
    const {isUserLoggedIn} =  this.props;
    const {isUserLoggedIn:isUserLoggedInPrev} =  prevProps;
    if(isUserLoggedIn !== isUserLoggedInPrev){
      this.redirectUser();
    }
    
  }

  redirectUser(){
    const {state} = this.props.location;
    //console.log(state);
    window.location = (state) ? state.from.pathname:"/dashboard";  
  }

  submitLocal=()=>{
    const {clearErrors,login} = this.props;
    clearErrors();
    login({
      ...this.state.data
    })
  }

  validateLocal = ()=>{

  }

  render() {
    const {data,errors:localErrors} = this.state;
    const {processingModalDisplayFlag,errors:serverErrors} = this.props
    const {username,password} = data;

    return (
      <Fragment>
        <div className="app-wrapper min-vh-100">
          <div className="app-main min-vh-100">
            <div className="app-content p-0">
              <div className="app-content--inner d-flex align-items-center">
                <div className="flex-grow-1 w-100 d-flex align-items-center">
                  <div className="bg-composed-wrapper--content py-5">
                    <div className="container">
                      <Row>
                        <Col
                          lg="5"
                          className="d-none d-lg-flex align-items-center">
                          <img
                            alt="..."
                            className="w-100 mx-auto d-block img-fluid"
                            src={loginLogo}
                          />
                        </Col>
                        <Col
                          lg="7"
                          sm="12"
                          className=" d-flex justify-content-center align-items-center">
                          <div className="" id="formArea">
                            <div className="mt-3">
                              <div className="d-block d-lg-none mb-3">
                                <img
                                    alt="..."
                                    className="d-block d-lg-none mx-auto d-block img-fluid"
                                    src={loginLogo}
                                    style={{ width:"200px", height:"200px", }}
                                />
                              </div>
                              <span className="text-left text-sm-center">
                                <h2 className="d-none d-sm-block display-3 text-left mb-1 font-weight-bold">
                                  Customer Portal
                                </h2>
                                <h2 className="d-block d-sm-none display-4 text-left mb-1 font-weight-bold">
                                  Customer Portal
                                </h2>
                                <p className="text-black-50 text-left mb-1">
                                  Please enter your login details:
                                </p>
                              </span>
                              <div>
                                <div id="errorArea">
                                    {/*Error display */}
                                      {   !_.isEmpty(localErrors) &&
                                          <FormErrorWidget
                                              errors={localErrors}
                                              displayFirstColumnAsSpace={false}
                                          />
                                      }

                                      {   !_.isEmpty(serverErrors) &&
                                          <ServerErrorWidget
                                              errors={serverErrors}
                                              displayAsAlert={true}
                                          />
                                      }
                                    {/* End of Error display */}
                                </div>
                                <Form onSubmit={this.submitForm}>
                                  <FormGroup>
                                    <label>Email address</label>
                                    <Input
                                      placeholder="Email"
                                      type="email"
                                      name="username"
                                      id="username"
                                      value={username}
                                      onChange={this.handleChange}
                                    />
                                  </FormGroup>
                                  <div className="form-group mb-4">
                                    <div className="d-flex justify-content-between">
                                      <label>Password</label>
                                    </div>
                                    <Input
                                      placeholder="Password"
                                      type="password"
                                      name="password"
                                      id="password"
                                      value={password}
                                      onChange={this.handleChange}
                                    />
                                    <div className="d-flex justify-content-between mt-1">
                                      <label></label>
                                      <Link to="/forgot-password">
                                        Forgot password?
                                      </Link>
                                    </div>
                                  </div>

                                  <Button className="d-none" type="submit" size="lg" block={true} color="primary"
                                    onClick={this.submitForm} 
                                  >
                                    Login
                                  </Button>

                                  <LaddaButton className="ml-auto btn btn-primary btn-lg btn-block"
                                          loading={processingModalDisplayFlag}
                                          onClick={this.submitForm} 

                                          data-style={EXPAND_LEFT}
                                  >
                                    {  processingModalDisplayFlag === true ? "Logging you in":"Login"}
                                  </LaddaButton>      

                                </Form>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <FooterMinimalLayout />
              </div>
            </div>
          </div>
        </div>

        {/* Processing Modal */}
        <ProcessingModal
            displayModal={false}
            handleCloseOfModalWindow={()=>{}}
        />
        {/* Processing Modal */}
        
      </Fragment>
    );
  }
}

const mapStateToProps = state=>({
  processingModalDisplayFlag:state.auth.loading,
  errors:getLoginErrors(state),
  isUserLoggedIn:isUserLoggedIn(state),
});

const mapDispatchToProps = (dispatch)=>({
  clearErrors:()=>dispatch(clearErrors()),
  login:(authenticationObject)=>dispatch(login(authenticationObject)),
});

export default connect(mapStateToProps,mapDispatchToProps)(LoginForm);

